import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, Ref, ref, watch } from "vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import {
    BorrowCalculatorInterface,
    BorrowCalculatorFields,
    CalculatorOptions,
    CalculatorOptionsFields,
    Periodicity,
    getPeriodicityKey,
    RepaymentFre,
    getRepaymentByFre,
    BorrowCalculatorResult,
  } from "@/types/BorrowCalculator";
  import { formatPorcentageTrim } from "@/helpers/transformation/price";
  import store from "@/store";
  import { POSITION, useToast } from "vue-toastification";
  import { AxiosResponse } from "axios";

  type propsType = {
    form: BorrowCalculatorInterface;
    formCalculatorOptions: CalculatorOptions;
  };
  const maxInterestRateAmount = 50;
  const noteText =
    "Note: The information provided by the calculator is intended to provide illustrative examples based on stated assumptions and your inputs. Calculations are meant as estimates only and it is advised that you consult with a mortgage broker about your specific circumstances.";

export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorResultSection',
  props: {
    form: {},
    formCalculatorOptions: {}
  },
  emits: [
    "updateForm",
    "updateFormCalculatorOptions",
    "result",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const toast = useToast();
  const props = __props;
  const loading = ref(true);
  const interestRateAmount = ref<number[]>([]);
  const result = ref<BorrowCalculatorResult>({
    LoanAmountString: null,
    LoanBalanceString: null,
    RepaymentFortnightlyString: null,
    RepaymentMonthlyString: null,
    RepaymentWeeklyString: null,
    TableStr: null,
    TotalPaymentString: null,
  });

  const updateForm = (field: BorrowCalculatorFields, value: string) => {
    emits("updateForm", field.toString(), value);
  };

  const updateFormInput = (e: Event, field: BorrowCalculatorFields) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    const value = target.value.replace(/%/g, "");
    const income = formatPorcentageTrim(value, 50);

    emits("updateForm", field, income);
    getResult();
  };

  const fillInterestRateAmount = (amount: number) => {
    for (let i = 1; i <= amount; i++) {
      interestRateAmount.value.push(i);
    }
  };

  const updateFormCalculatorOptions = (
    field: CalculatorOptionsFields,
    value: "1" | "2" | boolean
  ) => {
    emits("updateFormCalculatorOptions", field.toString(), value);
  };

  const getResult = async () => {
    store
      .dispatch("borrowCalculator/getCalculatorResult", props.form)
      .then((res: BorrowCalculatorResult) => {
        result.value = res;
        emits("result", res);
      })
      .catch(() =>
        toast.error("Something went wrong on getting result", {
          position: POSITION.TOP_LEFT,
        })
      )
      .finally(() => (loading.value = false));
  };

  onMounted(() => {
    fillInterestRateAmount(maxInterestRateAmount);
    getResult();
  });

  
const __returned__ = { emits, toast, props, maxInterestRateAmount, loading, interestRateAmount, result, updateForm, updateFormInput, fillInterestRateAmount, updateFormCalculatorOptions, getResult, noteText, computed, onMounted, Ref, ref, watch, DropDown, get BorrowCalculatorInterface() { return BorrowCalculatorInterface }, get BorrowCalculatorFields() { return BorrowCalculatorFields }, get CalculatorOptions() { return CalculatorOptions }, get CalculatorOptionsFields() { return CalculatorOptionsFields }, get Periodicity() { return Periodicity }, get getPeriodicityKey() { return getPeriodicityKey }, get RepaymentFre() { return RepaymentFre }, get getRepaymentByFre() { return getRepaymentByFre }, get BorrowCalculatorResult() { return BorrowCalculatorResult }, get formatPorcentageTrim() { return formatPorcentageTrim }, get store() { return store }, get POSITION() { return POSITION }, get useToast() { return useToast }, get AxiosResponse() { return AxiosResponse } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})